import Vue from 'vue';
export const KpiGlobalEvents = new Vue();

export const EVENT_ON_CHANGE_BALANCE_SETTINGS = 'onBalanceSettingChange';